import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Pages from './Pages';

const propTypes = {
  currentPage: PropTypes.number.isRequired,
  pagesDisplayed: PropTypes.number,
  resultsPerPage: PropTypes.number,
  totalResults: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
};

const defaultProps = {
  pagesDisplayed: 5,
  resultsPerPage: 10,
};

const useStyles = makeStyles(() => ({
  hidden: {
    display: 'none',
  },
}));

const Pagination = (props) => {
  const classes = useStyles();
  const {
    currentPage,
    pagesDisplayed,
    resultsPerPage,
    totalResults,
    onChangePage,
  } = props;

  const actions = (p) => {
    return (<Pages pagesDisplayed={pagesDisplayed} {...p} />);
    // console.log(p);
  };

  return (
    <TablePagination
      // Oculta los elementos no usados
      classes={{ caption: classes.hidden, spacer: classes.hidden }}
      component="div"
      count={totalResults}
      page={currentPage}
      rowsPerPage={resultsPerPage}
      onChangePage={onChangePage}

      // Renderiza las páginas (botones)
      ActionsComponent={actions}

      // Oculta elementos no usados
      labelDisplayedRows={() => null}
      labelRowsPerPage={null}
      rowsPerPageOptions={[]}
    />
  );
};

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;

export default Pagination;
